<template>

<div class="delete" :class="{'is-loading': isLoading}">

	<app-icon icon="warning" class="delete-icon" />

	<div class="delete-title">Delete {{ noun }}</div>

	<div class="delete-text" v-if="count === 1">Are you sure you wish to delete the {{ noun }} <b>{{ title }}</b>? This cannot be reversed.</div>
	<div class="delete-text" v-if="count > 1">Are you sure you wish to delete the <b>{{ count }} selected</b> {{ noun }}? This cannot be reversed.</div>

	<div class="delete-buttons">

		<div class="delete-buttons-item is-danger" v-on:click="onConfirmClick">
			<template v-if="!isLoading">Confirm</template>
			<app-icon icon="loading" v-if="isLoading" />
		</div>

		<div class="delete-buttons-item" v-on:click="onCancelClick">Cancel</div>

	</div>

</div>

</template>

<script>

export default {

	data: function() {

		return {
			isLoading: false
		}

	},

	computed: {

		count: function() {
		
			return (this.$route.meta.param) ? 1 : this.$route.query.items.split(',').length
		
		},

		model: function() {

			return this.$store.getters[this.$route.meta.store + '/find'](this.$route.params[this.$route.meta.param])

		},

		noun: function() {

			return (this.count > 1) ? this.$route.meta.noun.replace('ry', 'ie').toString() + 's' : this.$route.meta.noun

		},

		title: function() {

			return (this.model) ? this.model.title : false

		}

	},

	methods: {

		onConfirmClick: async function() {
			
			this.isLoading = true

			await this.$store.dispatch(this.$route.meta.store + '/delete', {
				id: (this.$route.meta.param) ? this.$route.params[this.$route.meta.param] : this.$route.query.items
			})

			await this.$store.dispatch('load')

			this.$router.push({
				name: this.$route.meta.parent
			})
			
		},

		onCancelClick: function() {
			
			this.$router.push({
				name: this.$route.meta.back
			})

		}

	}

}

</script>

<style scoped>

.delete {
	position: absolute;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: #f25151;
}

.delete.is-loading {
	pointer-events: none;
}

.delete-icon {
	font-size: 96px;
}

.delete-title {
	font-size: 24px;
	font-weight: 400;
	padding: 20px 0px;
}

.delete-text {
	font-size: 16px;
	line-height: 20px;
	padding: 0px 100px;
	text-align: center;
	color: #333;
	font-weight: 300;
}

.delete-buttons {
	margin-top: 20px;
	display: flex;
	justify-content: center;
}

.delete-buttons-item {
	width: 150px;
	height: 40px;
	border: 2px solid #ccc;
	line-height: 36px;
	text-align: center;
	border-radius: 16px;
	color: #333;
	margin: 0px 10px;
	font-size: 16px;
	cursor: pointer;
}

.delete-buttons-item.is-danger {
	color: #fff;
	font-weight: 400;
	border-color: #f25151;
	background-color: #f25151;
}

</style>
